/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolBlenderIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-blender"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M8.15 22.8Q7.05 22.8 6.28 22.02Q5.5 21.25 5.5 20.15L5.5 19.15Q5.5 17.88 6.03 16.79Q6.55 15.7 7.35 14.95L6.8 11.15L4.45 11.15Q3.35 11.15 2.58 10.38Q1.8 9.6 1.8 8.5L1.8 4.85Q1.8 3.73 2.56 2.96Q3.33 2.2 4.45 2.2L9.65 2.2L9.65 2.2Q9.65 1.77 9.94 1.49Q10.22 1.2 10.65 1.2L13.8 1.2Q14.22 1.2 14.51 1.49Q14.8 1.77 14.8 2.2L14.8 2.2L17.43 2.2Q18.02 2.2 18.43 2.66Q18.82 3.13 18.73 3.73L17.1 14.95Q17.9 15.7 18.43 16.79Q18.95 17.88 18.95 19.15L18.95 20.15Q18.95 21.25 18.18 22.02Q17.4 22.8 16.3 22.8ZM6.42 8.5L5.88 4.85L4.45 4.85Q4.45 4.85 4.45 4.85Q4.45 4.85 4.45 4.85L4.45 8.5Q4.45 8.5 4.45 8.5Q4.45 8.5 4.45 8.5ZM12.22 19.3Q12.22 19.3 12.47 19.3Q12.72 19.3 13.07 18.95Q13.43 18.6 13.43 18.1Q13.43 17.6 13.07 17.25Q12.72 16.9 12.22 16.9Q11.72 16.9 11.38 17.25Q11.03 17.6 11.03 18.1Q11.03 18.6 11.38 18.95Q11.72 19.3 12.22 19.3ZM9.8 13.45L14.63 13.45L15.88 4.85L8.55 4.85Z" fill={color} />
    </svg>
  );
}
